export enum MmReportTypeEnum {
    faultsList = 'list',
    report = 'report',
    writing = 'writing',
    writingPreview = 'writingPreview',
    writingPreviewEmailBody = 'writingPreviewEmailBody'
}
